<app-venda-modal-v2
  *ngIf="venda"
  [isOpen]="isModalBaixarParcelaOpen"
  [venda]="venda"
  [tipoAcao]="'BAIXAR_PARCELA'"
  [permitirVendaMista]="false"
  [valorDisponivel]="valorDisponivelParaLancamento"
  (closeModal)="fecharModalBaixarParcela($event)">
</app-venda-modal-v2>

<app-confirm-dialog
  [isOpen]="isConfirmDialogOpen"
  [title]="'Kali ERP: Confirmação'"
  [message]="'Deseja dar baixar nesta parcela de cartao?'"
  [cancelLabel]="'Nao'"
  [confirmLabel]="'Sim'"
  (cancelled)="fecharDialogConfirmacao()"
  (confirmed)="confirmarBaixaParcelaCartao()">
</app-confirm-dialog>


<section class="conta-receber-shell">
  <header class="conta-receber-hero">
    <div>
      <h2 class="conta-receber-title">Conta a Receber — Manutenção</h2>
      <p class="conta-receber-subtitle">Visualize os dados da venda e gerencie as parcelas.</p>
    </div>
    <span class="badge bg-secondary" *ngIf="idVenda">Venda {{ idVenda }}</span>
  </header>

  <div *ngIf="isLoading" class="alert alert-info" role="alert">
    Carregando dados da venda...
  </div>

  <div *ngIf="!isLoading && errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <div *ngIf="!isLoading && !errorMessage && venda" class="manutencao-grid-wrapper">
    <section class="bloco-secao">
      <h4 class="secao-titulo">Header - Dados da Venda</h4>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">ID da Venda</label>
            <input type="text" class="form-control" [value]="venda.id" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">ID Orcamento</label>
            <input type="text" class="form-control" [value]="venda.idOrcamento" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Data da Venda</label>
            <input type="text" class="form-control" [value]="formatDate(venda.dataVenda, true)" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Data Conclusão</label>
            <input type="text" class="form-control" [value]="formatDate(venda.dataConclusao)" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Forma de Pagamento</label>
            <input type="text" class="form-control" [value]="venda.formaPagamento" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Status da Venda</label>
            <input type="text" class="form-control" [value]="venda.statusVenda" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Total da Venda</label>
            <input type="text" class="form-control" [value]="formatCurrency(venda.totalVenda)" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Saldo Devedor</label>
            <input type="text" class="form-control" data-testid="saldo-devedor-venda" [value]="formatCurrency(venda.saldoDevedor)" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Número de Parcelas</label>
            <input type="text" class="form-control" [value]="venda.numParcelas" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Parcelas Abertas</label>
            <input type="text" class="form-control" [value]="venda.parcelasAbertas" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Valor da Parcela</label>
            <input type="text" class="form-control" [value]="formatCurrency(venda.valorParcela)" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Taxa Maquininha</label>
            <input type="text" class="form-control" [value]="formatCurrency(venda.taxaMaquininha)" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Bandeira Cartão</label>
            <input type="text" class="form-control" [value]="venda.bandeiraCartao || '-'" readonly>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">Previsão de Entrega</label>
            <input type="text" class="form-control" [value]="formatDate(venda.previsaoEntrega)" readonly>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label">Última Atualização</label>
            <input type="text" class="form-control" [value]="formatDate(venda.ultimaAtualizacao, true)" readonly>
          </div>
        </div>
      </div>
    </section>

    <div class="action-buttons mb-4 d-flex justify-content-end" *ngIf="podeExibirAdicionarPagamento">
      <button type="button" class="btn btn-success" data-testid="btn-adicionar-pagamento" (click)="abrirModalBaixarParcela()">
        Adicionar Pagamento
      </button>
    </div>

    <section class="bloco-secao">
      <h4 class="secao-titulo">Body</h4>

      <div *ngIf="isBodyLoading" class="alert alert-info" role="alert">
        Carregando parcelas da conta a receber...
      </div>

      <div *ngIf="!isBodyLoading && bodyErrorMessage" class="alert alert-danger" role="alert">
        {{ bodyErrorMessage }}
      </div>

      <div class="table-responsive" *ngIf="!isBodyLoading && !bodyErrorMessage" id="parcelas">
        <table class="table table-striped table-hover">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Parcela</th>
              <th scope="col" class="text-center">Vencimento</th>
              <th scope="col" class="text-end">Valor Previsto</th>
              <th scope="col" class="text-end">Valor Recebido</th>
              <th scope="col" class="text-center">Forma Pagto.</th>
              <th scope="col" class="text-center">Status</th>
              <th scope="col" class="text-center">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of contasReceberVenda">
              <td>{{ item.numParcela }}</td>
              <td class="text-center">{{ item.dataVencimento | date:'dd/MM/yyyy' }}</td>
              <td class="text-end" data-testid="parcela-valor-previsto">{{ item.valorPrevisto | currency:'BRL' }}</td>
              <td class="text-end">{{ item.valorRecebido | currency:'BRL' }}</td>
              <td class="text-center">{{ item.descricaoMetodoPagamento }}</td>
              <td class="text-center">{{ item.status }}</td>
              <td class="text-center">
                <button
                  *ngIf="item.status.toUpperCase() === 'ABERTO'"
                  type="button"
                  class="btn btn-outline-primary btn-sm"
                  (click)="baixarParcelaCartao(item)">
                  Baixar Parcela
                </button>
              </td>
            </tr>
            <tr *ngIf="contasReceberVenda.length === 0">
              <td colspan="6" class="text-center text-muted py-4">
                Nenhuma parcela encontrada para esta venda.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="voltarParaContasAReceber()">Voltar</button>
  </footer>
</section>
